(() => {
  const skip = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE']);
  const hiddenReviewText = 'and i love buying from a local business';
  const deadSkinReviewImage = 'puzzle-pup-co-dog-supplement-soft-chews-default-title-puzzlepup-skin-coat-soft-chews-31662924529804.png';
  const currentSkinReviewImage = 'https://cdn.shopify.com/s/files/1/0723/3798/1580/files/puzzlepup-skin-coat-soft-chews-primary-cover-1x1_8a5c71d0-a269-4c79-ae81-28a818d3cdf3.png?v=1785208859&width=900';

  const removeHiddenReview = (root) => {
    if (!root) return false;

    const element = root.nodeType === Node.TEXT_NODE ? root.parentElement : root;
    if (!element) return false;

    const enclosingCard = element.closest?.('.pp-v3-review-card');
    if (enclosingCard?.textContent?.toLowerCase().includes(hiddenReviewText)) {
      enclosingCard.remove();
      return true;
    }

    let removed = false;
    const cards = [];
    if (element.matches?.('.pp-v3-review-card')) cards.push(element);
    element.querySelectorAll?.('.pp-v3-review-card').forEach((card) => cards.push(card));
    cards.forEach((card) => {
      if (card.textContent?.toLowerCase().includes(hiddenReviewText)) {
        card.remove();
        removed = true;
      }
    });

    return removed;
  };

  const clean = (value) => value
    .replace(/\s*\u2014\s*/g, ': ')
    .replace(/\bSupport\b/g, 'Care')
    .replace(/\bsupport\b/g, 'care');

  const cleanText = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || skip.has(node.parentElement?.tagName)) return;
    const next = clean(node.nodeValue || '');
    if (next !== node.nodeValue) node.nodeValue = next;
  };

  const cleanAttributes = (element) => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return;
    if (element.matches('img') && (element.getAttribute('src') || '').includes(deadSkinReviewImage)) {
      element.setAttribute('src', currentSkinReviewImage);
      element.removeAttribute('srcset');
    }
    ['alt', 'title', 'aria-label'].forEach((name) => {
      if (!element.hasAttribute(name)) return;
      const value = element.getAttribute(name) || '';
      const next = clean(value);
      if (next !== value) element.setAttribute(name, next);
    });
  };

  const cleanTree = (root) => {
    if (!root) return;
    if (removeHiddenReview(root)) return;
    if (root.nodeType === Node.TEXT_NODE) {
      cleanText(root);
      return;
    }
    cleanAttributes(root);
    root.querySelectorAll?.('img, [alt], [title], [aria-label]').forEach(cleanAttributes);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) cleanText(node);
  };

  const start = () => {
    cleanTree(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') cleanText(mutation.target);
        if (mutation.type === 'attributes') cleanAttributes(mutation.target);
        mutation.addedNodes.forEach(cleanTree);
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['alt', 'title', 'aria-label', 'src', 'srcset'], childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
